/**
 * `src/explore` public surface. Owner: Exploration — P6 (`sim/`, `chronicle/`, map, towns, quests, «Сводка») and P7
 * (`dungeon/`, `orders/`). Watched fights and map tokens go through `ctx.services.combat` /
 * `ctx.services.creatures.anim`; never import combat/creature/cards/meta runtime (architecture §1.1).
 */
import type { FeatureModule } from '../shared';
import { explorationSlice, readExplore } from './save';
import { exploreScreens } from './screens';

export const explore: FeatureModule = {
  key: 'explore',
  slices: [explorationSlice],
  screens: exploreScreens,
  onBoot: ctx => {
    ctx.services.explore = { summaryForDashboard: () => {
      const s = readExplore(ctx.store.state.slices.exploration);
      return { regionKey: 'explore.title', stateKey: s.run?.status === 'active' ? 'explore.resume' : 'explore.road', lastLines: s.run?.trek?[ctx.t('explore.voyage.atlas',{n:s.atlas.length}),ctx.t(`explore.voyage.quest.${s.run.trek.quest}`)]:s.run?.history.slice(-2).map(line => ctx.t(line.hurt ? 'explore.log.hurt' : 'explore.log.safe', { choice: ctx.t(`explore.choice.${line.choice}`), n: line.loot })) ?? [] };
    } };
  },
  debugApi: () => ({ explore: {} }),
};

export { explorationSlice, type ExplorationSave } from './save';
